(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var campaignKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'fbclid'
  ];

  var currentParams = new URLSearchParams(window.location.search);
  var campaignParams = new URLSearchParams();

  campaignKeys.forEach(function (key) {
    var value = currentParams.get(key);
    if (value) campaignParams.set(key, value);
  });

  document.querySelectorAll('a[href]').forEach(function (link) {
    var url;

    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.hostname !== 'cantinaantica.plateform.app') return;

    campaignParams.forEach(function (value, key) {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value);
    });

    link.href = url.toString();
  });

  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-track]');
    if (!trigger) return;

    var destination = trigger.getAttribute('href') || '';
    window.dataLayer.push({
      event: trigger.dataset.track,
      link_url: destination,
      link_text: (trigger.textContent || '').trim(),
      page_path: window.location.pathname
    });
  });

  document.querySelectorAll('.mobile-nav a').forEach(function (link) {
    link.addEventListener('click', function () {
      var menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
    });
  });

  var cookieButton = document.querySelector('[data-cookie-preferences]');
  if (cookieButton) {
    cookieButton.addEventListener('click', function () {
      var privacyButton = document.querySelector(
        '#shopify-privacy-banner-button-div button, [data-shopify-privacy-settings-button]'
      );

      if (privacyButton && privacyButton !== cookieButton) {
        privacyButton.click();
      } else {
        window.dispatchEvent(new CustomEvent('cantina:cookie-preferences'));
      }
    });
  }
})();
